import type { TaskResponse } from '../client';
import type { TasksSortingOption } from '../models';

/** Extract the numeric part from a `PREFIX-NUMBER` ID (e.g. "RED-42" → 42). */
function parseIdNum(id: string): number {
  return parseInt(id.match(/^\w+-(\d+)$/)?.[1] || '0', 10);
}

export function sortTasks(tasks: TaskResponse[], option: TasksSortingOption): TaskResponse[] {
  switch (option) {
    case 'task-id':
      return tasks.slice().sort((a, b) => parseIdNum(a.id) - parseIdNum(b.id));
    case 'task-id-desc':
      return tasks.slice().sort((a, b) => parseIdNum(b.id) - parseIdNum(a.id));
    case 'feature':
      return tasks.slice().sort((a, b) => parseIdNum(a.feature_id) - parseIdNum(b.feature_id));
    case 'feature-desc':
      return tasks.slice().sort((a, b) => parseIdNum(b.feature_id) - parseIdNum(a.feature_id));
    case 'size':
      return tasks.slice().sort((a, b) => b.total_effort - a.total_effort);
    case 'size-desc':
      return tasks.slice().sort((a, b) => a.total_effort - b.total_effort);
    case 'game':
      return tasks.slice().sort((a, b) => a.type.localeCompare(b.type));
    case 'game-desc':
      return tasks.slice().sort((a, b) => b.type.localeCompare(a.type));
    default:
      throw Error(`Sort option not implemented: ${option}`);
  }
}
